document.addEventListener('alpine:init', () => {
  Alpine.data('CollectionsTabbed', (current_tab) => ({
    current_tab: null,
    init() {
      this.current_tab = current_tab;
      this.InitWatchers();
    },
    InitWatchers() {
      this.$watch('current_tab', () => {
        // to fix arrow positions
        this.$nextTick(() => {
          window.dispatchEvent(new Event('resize', { bubbles: true }));
        });
      });
    }
  }));

  Alpine.data('LoadFeaturedCollection', (collection_handle, sectionId) => ({
    collection_handle: collection_handle,
    sectionId: sectionId,
    init() {
      this.InitSelf();
      this.InitWatchers();
    },
    async InitSelf() {
      let response = await fetch(`/collections/${this.collection_handle}?&section_id=${this.sectionId}`);
      let html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      this.$el.querySelector('.section-inner').replaceWith(doc.querySelector('.section-inner'));

      // Notify that a section has been loaded to reinitialize scripts
      this.$nextTick(() => {
        document.dispatchEvent(new Event('shopify:section:loaded'));
      });
    }
  }));

  Alpine.data('CheckFinalSale', () => ({
    variant: null,
    get IsFinalSale() {
      if (!this.variant) return false;
      // check if 60% off
      const compareAtPrice = this.variant.compare_at_price || this.variant.price;
      const discount = (compareAtPrice - this.variant.price) / compareAtPrice;
      return discount >= 0.6;
    },
    init() {
      this.variant = JSON.parse(this.$el.dataset.variant);
      this.InitWatchers();
    },
    InitWatchers() {
      subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
        this.variant = e.data.variant;
      });
    }
  }));
});